/* Scoped to .auth-page (added to <body> in the entry HTML) — NOT a bare body{} selector.
   All entries share one CSS file (cssCodeSplit: false), so a bare body{} background would
   leak this dark auth background into the main app. Prod ejs templates also set it inline. */
body.auth-page {
  background: #1e282d;
}
